export default __webpack_public_path__ + "static/media/project2.6f3c4679.PNG";